import { DomainEvent } from "../model/domain-event.model";
import { ServiceSelection } from "@features/service/application/stores/service.store";

export class ServiceSelectionChangedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor(public readonly payload: ServiceSelection | null) {}
}
